import { NgClass } from '@angular/common';
import { Component, computed, inject } from '@angular/core';
import { ToastService } from '@core/services/toast.service';
ToastService;
@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [NgClass],
  template: `
    <div
      class="fixed z-[9999] top-4 right-4 space-y-3 w-[300px] max-h-[90vh] cursor-pointer overflow-y-auto scrollbar-hide"
    >
    @for (t of toasts(); track t.id) {
      <div
        class="rounded-lg px-4 py-3 h-full shadow-lg text-white flex items-center justify-center gap-3 transition
               hover:shadow-xl"
        [ngClass]="bg(t.type)"
        (click)="dismiss(t.id)"
        role="status"
        aria-live="polite"
      >
        <!-- <div class="mt-0.5 text-lg leading-none">🔔</div> -->
         <img src="assets/SVG/noti-dot.svg" alt="success" class="w-3 h-3">
        <div class="flex-1 leading-snug">{{ t.message }}</div>
        <button class="opacity-80 hover:opacity-100 cursor-pointer" aria-label="Dismiss">
          ✕
        </button>
      </div>
    }
    </div>
  `,
})
export class ToastContainerComponent {
  private toast = inject(ToastService);
  toasts = computed(() => this.toast.toasts());

  dismiss(id: number) {
    this.toast.dismiss(id);
  }

  bg(type: 'success' | 'error' | 'info' | 'warning') {
    return {
      'bg-[#51a351]': type === 'success',
      'bg-[#bd362f]': type === 'error',
      'bg-[var(--primary-color)]': type === 'info',
      'bg-[#f89406]': type === 'warning',
    };
  }
}
